interface MessageData {
	origin: string;
	type: string;
	payload: object;
}

interface ListenerGroup {
	type: string;
	callbacks: ((data: MessageData) => void)[];
}

export class IntegrationCommunicator {
	private static listenerGroups: ListenerGroup[] = [];

	public static start() {
		IntegrationCommunicator.setup();
	}

	public static stop() {
		document.removeEventListener(
			"message",
			IntegrationCommunicator.handlePostMessage
		);
	}

	public static on(type: string, callback: (data: MessageData) => void) {
		const groupIndex = IntegrationCommunicator.getListenerGroupIndexByType(
			type
		);

		if (groupIndex > -1) {
			IntegrationCommunicator.listenerGroups[groupIndex].callbacks.push(
				callback
			);
		} else {
			IntegrationCommunicator.listenerGroups.push({
				type,
				callbacks: [callback]
			});
		}
	}

	public static send(type: string, payload: object) {
		const json = JSON.stringify({
			type,
			payload
		});

		if ((window as any).ReactNativeWebView) {
			(window as any).ReactNativeWebView.postMessage(json);
		} else {
			window.postMessage(json, "*");
		}
	}

	public static request(type: string) {
		IntegrationCommunicator.send(type, {});
	}

	private static parseMessage(message: string): MessageData {
		try {
			return JSON.parse(message);
		} catch (e) {
			return null;
		}
	}

	private static getListenerGroupIndexByType(type: string) {
		return IntegrationCommunicator.listenerGroups.findIndex(
			listener => listener.type === type
		);
	}

	private static handlePostMessage = (event: MessageEvent) => {
		const data = IntegrationCommunicator.parseMessage(event.data);

		if (!data) {
			return;
		}

		const groupIndex = IntegrationCommunicator.getListenerGroupIndexByType(
			data.type
		);

		if (groupIndex > -1) {
			IntegrationCommunicator.listenerGroups[
				groupIndex
			].callbacks.forEach(cb => {
				cb(data);
			});
		}
	};

	private static setup() {
		document.addEventListener(
			"message",
			IntegrationCommunicator.handlePostMessage
		);
		window.addEventListener(
			"message",
			IntegrationCommunicator.handlePostMessage
		);
	}
}
